import { types } from "redux/types";

export const openURL = ({url, target}, dispatch) => {
    dispatch({
        type: types.OPEN_URL,
        url,
        target,
        userActionData: { url }
    });
}